export const translations = {
  es: {
    // Navigation
    'nav.dashboard': 'Panel Principal',
    'nav.patients': 'Pacientes',
    'nav.appointments': 'Citas',
    'nav.billing': 'Facturación',
    'nav.pharmacy': 'Farmacia',
    'nav.lab': 'Laboratorio',
    'nav.analytics': 'Analíticas',
    'nav.safety': 'Bandeja de Seguridad',
    'nav.audit': 'Registros de Auditoría',
    'nav.organizations': 'Organizaciones',
    'nav.feature_flags': 'Funcionalidades',
    'nav.ai_chat': 'Chat IA',
    'nav.settings': 'Configuración',
    'nav.clinic': 'Clínica',
    'nav.system': 'Sistema',

    // Sidebar (rendered navigation labels)
    'sidebar.home': 'Inicio',
    'sidebar.group.main': 'Principal',
    'sidebar.group.clinical': 'Clínico',
    'sidebar.group.administrative': 'Administrativo',
    'sidebar.group.system': 'Sistema',
    'sidebar.agenda': 'Agenda',
    'sidebar.patients': 'Pacientes',
    'sidebar.appointments': 'Citas',
    'sidebar.availability': 'Mi Disponibilidad',
    'sidebar.billing': 'Facturacion',
    'sidebar.medications': 'Medicamentos',
    'sidebar.settings': 'Configuracion',
    'sidebar.audit': 'Auditoría',
    'sidebar.new_appointment': 'Nueva Cita',
    'sidebar.logout': 'Cerrar Sesion',
    'settings.page_title': 'Configuracion',
    'settings.page_subtitle': 'Refine su espacio de trabajo clinico. Gestione su perfil profesional, comportamientos del sistema y ventanas de disponibilidad.',
    'settings.profile_information': 'Informacion del Perfil',
    'settings.full_name': 'Nombre Completo',
    'settings.email': 'Correo Electronico',
    'settings.role': 'Rol',
    'settings.clinic_availability': 'Disponibilidad Clinica',
    'settings.timezone': 'Zona Horaria',
    'settings.consult_duration': 'Duracion de Consulta',
    'settings.lead_time': 'Tiempo de Anticipacion',
    'settings.max_horizon': 'Horizonte Maximo',
    'settings.unit_min': 'min',
    'settings.unit_days': 'dias',
    'settings.save_rules': 'Guardar Reglas',
    'settings.system_preferences': 'Preferencias del Sistema',
    'settings.language_desc': 'Idioma de la interfaz.',
    'settings.weekly_windows': 'Ventanas Semanales',
    'settings.no_weekly_windows': 'Sin ventanas semanales configuradas.',
    'settings.add_window_hint': 'Agregue una ventana para comenzar.',
    'settings.add_window': 'Agregar horario',
    'settings.add_exception_window': 'Agregar Ventana Excepcional',
    'settings.exception': 'Excepcion',
    'settings.date_exceptions': 'Excepciones de Fecha',
    'settings.closed': 'Cerrado',
    'settings.discard_changes': 'Descartar Cambios',
    'settings.save_changes': 'Guardar Cambios',
    'settings.weekday_short_0': 'Lun',
    'settings.weekday_short_1': 'Mar',
    'settings.weekday_short_2': 'Mie',
    'settings.weekday_short_3': 'Jue',
    'settings.weekday_short_4': 'Vie',
    'settings.weekday_short_5': 'Sab',
    'settings.weekday_short_6': 'Dom',
    'settings.theme_color': 'Color del tema',
    'settings.theme_color_desc': 'Personaliza el color principal de la interfaz.',
    'settings.theme_specialty': 'Tema por especialidad',
    'settings.theme_specialty_desc': 'Aplica una paleta predefinida según tu especialidad.',
    'settings.theme_peds_name': 'Pediatría',
    'settings.theme_gyne_name': 'Ginecología',
    'settings.theme_general_name': 'General',
    'settings.theme_professional_name': 'Profesional',
    'settings.theme_peds_desc': 'Cálido y amigable, muy limpio',
    'settings.theme_gyne_desc': 'Suave y sofisticado',
    'settings.theme_general_desc': 'Versátil y confiable',
    'settings.theme_professional_desc': 'Serio, sobrio y premium',
    'settings.dark_mode': 'Modo oscuro',
    'settings.theme_reset': 'Restaurar',
    'settings.theme_preview': 'Vista previa',
    'settings.preview_card_title': 'Tarjeta de ejemplo',
    'settings.preview_card_dimmed': 'Texto secundario atenuado',
    'settings.preview_primary': 'Primario',
    'settings.preview_secondary': 'Acento',
    'settings.preview_input': 'Campo enfocado',
    'availability.schedule_saved': 'Horario guardado exitosamente',
    'availability.schedule_save_error': 'No se pudo guardar el horario',

    // Common actions
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.view': 'Ver',
    'common.search': 'Buscar',
    'common.patient': 'Paciente',
    'common.dismiss': 'Descartar',
    'common.filter': 'Filtrar',
    'common.export': 'Exportar',
    'common.import': 'Importar',
    'common.create': 'Crear',
    'common.add': 'Agregar',
    'common.loading': 'Cargando...',
    'common.error': 'Error',
    'common.success': 'Éxito',
    'common.close': 'Cerrar',
    'common.back': 'Volver',
    'common.next': 'Siguiente',
    'common.previous': 'Anterior',
    'common.yes': 'Sí',
    'common.no': 'No',
    'common.confirm': 'Confirmar',
    'common.actions': 'Acciones',
    'common.status': 'Estado',
    'common.date': 'Fecha',
    'common.time': 'Hora',
    'common.description': 'Descripción',
    'common.name': 'Nombre',
    'common.email': 'Correo electrónico',
    'common.phone': 'Teléfono',
    'common.address': 'Dirección',
    'common.notes': 'Notas',
    'common.clear': 'Limpiar',
    'common.unread': 'sin leer',
    'common.development': 'Desarrollo Local',
    'common.all_rights_reserved': 'Todos los derechos reservados',
    'common.privacy_policy': 'Política de Privacidad',
    'common.terms_of_service': 'Términos de Servicio',
    'common.support': 'Soporte',
    
    // Status
    'status.active': 'Activo',
    'status.inactive': 'Inactivo',
    'status.discharged': 'Dado de Alta',
    'status.pending': 'Pendiente',
    'status.completed': 'Completado',
    'status.cancelled': 'Cancelado',
    'status.confirmed': 'Confirmado',
    
    // Dashboard
    'dashboard.title': 'Panel Principal',
    'dashboard.subtitle': 'Bienvenido de vuelta',
    'dashboard.metrics.title': 'Métricas clave',
    'dashboard.metrics.total_patients': 'Total de Pacientes',
    'dashboard.metrics.appointments_today': 'Citas de Hoy',
    'dashboard.metrics.pending_bills': 'Facturas Pendientes',
    'dashboard.metrics.avg_duration': 'Duración Prom.',
    'dashboard.quick_actions': 'Acciones Rápidas',
    'dashboard.actions_description': 'Operaciones frecuentes',
    'dashboard.recent_activity': 'Actividad Reciente',
    'dashboard.attention_required': 'Requieren Atención',
    'dashboard.todays_agenda': 'Agenda de Hoy',
    'dashboard.no_appointments_today': 'Sin citas programadas para hoy',
    'dashboard.greeting_morning': 'Buenos días',
    'dashboard.greeting_afternoon': 'Buenas tardes',
    'dashboard.greeting_evening': 'Buenas noches',
    
    // Quick actions
    'quick_actions.register_patient': 'Registrar Nuevo Paciente',
    'quick_actions.register_patient_desc': 'Crear un nuevo registro de paciente',
    'quick_actions.schedule_appointment': 'Agendar Cita',
    'quick_actions.schedule_appointment_desc': 'Reservar una nueva cita',
    'quick_actions.create_prescription': 'Crear Receta',
    'quick_actions.create_prescription_desc': 'Escribir una nueva receta',
    'quick_actions.open_safety_inbox': 'Abrir Bandeja de Seguridad',
    'quick_actions.open_safety_inbox_desc': 'Revisar eventos de seguridad clínica sin resolver',
    
    // Patients
    'patients.title': 'Pacientes',
    'patients.subtitle': 'Gestiona registros de pacientes, historiales médicos y planes de atención',
    'patients.search_placeholder': 'Buscar por nombre, correo o teléfono...',
    'patients.new_patient': 'Nuevo Paciente',
    'patients.edit_patient': 'Editar Paciente',
    'patients.view_profile': 'Ver Perfil',
    'patients.open_chart': 'Abrir Expediente',
    'patients.no_results': 'No se encontraron pacientes',
    'patients.no_results_desc': 'Intenta con otros términos de búsqueda o registra un nuevo paciente',
    'patients.total': 'Total de Pacientes',
    
    // Patient form
    'patient.form.first_name': 'Nombre(s)',
    'patient.form.last_name': 'Apellido(s)',
    'patient.form.email': 'Correo electrónico',
    'patient.form.phone': 'Teléfono',
    'patient.form.date_of_birth': 'Fecha de nacimiento',
    'patient.form.gender': 'Género',
    'patient.form.address': 'Dirección',
    'patient.form.occupation': 'Ocupación',
    'patient.form.emergency_contact': 'Contacto de emergencia',
    'patient.form.emergency_phone': 'Teléfono de emergencia',
    'patient.form.blood_type': 'Tipo de sangre',
    'patient.form.allergies': 'Alergias',
    'patient.form.medical_history': 'Historial médico',
    'patient.form.create_title': 'Registrar Nuevo Paciente',
    'patient.form.edit_title': 'Editar Paciente',
    'patient.form.create_desc': 'Complete el formulario para crear un nuevo registro',
    'patient.form.edit_desc': 'Actualice la información del paciente',
    
    // Appointments
    'appointments.title': 'Citas',
    'appointments.subtitle': 'Agendar y gestionar citas de pacientes',
    'appointments.new_appointment': 'Nueva Cita',
    'appointments.edit_appointment': 'Editar Cita',
    'appointments.create_title': 'Crear Nueva Cita',
    'appointments.create_description': 'Programar una nueva cita para un paciente',
    'appointments.today': 'Hoy',
    'appointments.month': 'Mes',
    'appointments.week': 'Semana',
    'appointments.day': 'Día',
    'appointments.doctor': 'Doctor',
    'appointments.patient': 'Paciente',
    'appointments.date_time': 'Fecha y Hora',
    'appointments.date': 'Fecha',
    'appointments.type': 'Tipo de Cita',
    'appointments.reason': 'Motivo',
    'appointments.status': 'Estado',
    'appointments.notes': 'Notas',
    'appointments.no_appointments': 'No hay citas programadas',
    'appointments.available_slots': 'Horarios Disponibles',
    'appointments.select_slot': 'Seleccionar un horario disponible',
    'appointments.book_appointment': 'Agendar Cita',
    'appointments.error_loading': 'Error al cargar citas',
    'appointments.error_creating': 'Error al crear cita',
    'appointments.error_loading_slots': 'Error al cargar horarios disponibles',
    'appointments.created_success': 'Cita creada exitosamente',
    'appointments.enter_patient_id': 'Ingresa el ID del paciente',
    'appointments.enter_doctor_id': 'Ingresa el ID del doctor',
    'appointments.duration': 'Duración',
    'appointments.minutes': 'min',
    'appointments.select_type': 'Seleccionar tipo',
    'appointments.no_slots_available': 'No hay horarios disponibles para esta fecha',
    'appointment_type.consultation': 'Consulta',
    'appointment_type.follow_up': 'Seguimiento',
    'appointment_type.emergency': 'Emergencia',
    'appointment_type.routine_checkup': 'Chequeo de Rutina',
    'appointment_type.vaccination': 'Vacunación',
    'appointment_type.lab_test': 'Prueba de Laboratorio',
    'appointment_type.telemedicine': 'Telemedicina',
    
    // Billing
    'billing.title': 'Facturación',
    'billing.subtitle': 'Gestiona facturas, pagos y reclamaciones de seguros',
    'billing.new_invoice': 'Nueva Factura',
    'billing.invoice_number': 'Número de Factura',
    'billing.amount': 'Monto',
    'billing.paid': 'Pagado',
    'billing.pending': 'Pendiente',
    'billing.overdue': 'Vencido',
    'billing.due_date': 'Fecha de Vencimiento',
    'billing.issue_date': 'Fecha de Emisión',
    'billing.payment_method': 'Método de Pago',
    'billing.insurance': 'Seguro',
    'billing.insurance_company': 'Compañía de Seguros',
    'billing.policy_number': 'Número de Póliza',
    'billing.subtotal': 'Subtotal',
    'billing.tax': 'Impuestos',
    'billing.total': 'Total',
    'billing.pay': 'Pagar',
    'billing.download': 'Descargar',
    
    // Pharmacy
    'pharmacy.title': 'Farmacia',
    'pharmacy.subtitle': 'Gestiona inventario de medicamentos y recetas',
    'pharmacy.new_prescription': 'Nueva Receta',
    'pharmacy.medication': 'Medicamento',
    'pharmacy.dosage': 'Dosis',
    'pharmacy.frequency': 'Frecuencia',
    'pharmacy.duration': 'Duración',
    'pharmacy.quantity': 'Cantidad',
    'pharmacy.instructions': 'Instrucciones',
    'pharmacy.prescribed_date': 'Fecha de Prescripción',
    'pharmacy.prescribed_by': 'Prescrito por',
    'pharmacy.stock': 'Existencias',
    'pharmacy.low_stock': 'Stock Bajo',
    'pharmacy.out_of_stock': 'Agotado',
    'pharmacy.add_medication': 'Agregar Medicamento',
    'pharmacy.edit_medication': 'Editar Medicamento',
    
    // Laboratory
    'lab.title': 'Laboratorio',
    'lab.subtitle': 'Gestiona órdenes de laboratorio y resultados',
    'lab.new_order': 'Nueva Orden',
    'lab.test_type': 'Tipo de Prueba',
    'lab.test_name': 'Nombre de la Prueba',
    'lab.results': 'Resultados',
    'lab.pending_results': 'Resultados Pendientes',
    'lab.review_results': 'Revisar Resultados',
    'lab.ordered_date': 'Fecha de Orden',
    'lab.completed_date': 'Fecha de Completado',
    'lab.ordering_doctor': 'Doctor Solicitante',
    'lab.priority': 'Prioridad',
    'lab.normal': 'Normal',
    'lab.abnormal': 'Anormal',
    'lab.critical': 'Crítico',
    'lab.upload_results': 'Subir Resultados',
    
    // Analytics
    'analytics.title': 'Analíticas',
    'analytics.subtitle': 'Métricas y reportes del sistema',
    'analytics.department_performance': 'Rendimiento por Departamento',
    'analytics.appointments_count': 'Número de Citas',
    'analytics.patients_count': 'Número de Pacientes',
    'analytics.revenue': 'Ingresos',
    'analytics.trend': 'Tendencia',
    'analytics.export_report': 'Exportar Reporte',
    
    // Safety
    'safety.title': 'Bandeja de Seguridad',
    'safety.subtitle': 'Eventos de seguridad clínica y gestión de incidentes',
    'safety.critical_events': 'Eventos Críticos',
    'safety.pending_review': 'Pendientes de Revisión',
    'safety.resolved': 'Resueltos',
    'safety.event_type': 'Tipo de Evento',
    'safety.severity': 'Severidad',
    'safety.due_date': 'Fecha Límite',
    'safety.assigned_to': 'Asignado a',
    'safety.report_event': 'Reportar Evento',
    
    // Audit
    'audit.title': 'Registros de Auditoría',
    'audit.subtitle': 'Bitácora de actividades del sistema',
    'audit.user': 'Usuario',
    'audit.action': 'Acción',
    'audit.resource': 'Recurso',
    'audit.timestamp': 'Fecha y Hora',
    'audit.ip_address': 'Dirección IP',
    'audit.details': 'Detalles',
    
    // Organizations
    'organizations.title': 'Organizaciones',
    'organizations.subtitle': 'Gestiona organizaciones y unidades de negocio',
    'organizations.new_organization': 'Nueva Organización',
    'organizations.business_units': 'Unidades de Negocio',
    'organizations.new_business_unit': 'Nueva Unidad de Negocio',
    'organizations.organization_name': 'Nombre de la Organización',
    'organizations.business_unit_name': 'Nombre de la Unidad',
    
    // Feature Flags
    'feature_flags.title': 'Funcionalidades',
    'feature_flags.subtitle': 'Gestiona características del sistema',
    'feature_flags.enabled': 'Activado',
    'feature_flags.disabled': 'Desactivado',
    'feature_flags.toggle': 'Alternar',
    
    // AI Chat
    'ai_chat.title': 'Chat IA',
    'ai_chat.subtitle': 'Asistente de inteligencia artificial',
    'ai_chat.type_message': 'Escribe tu mensaje...',
    'ai_chat.send': 'Enviar',
    'ai_chat.thinking': 'Pensando...',
    
    // Settings
    'settings.title': 'Configuración',
    'settings.subtitle': 'Configuración del sistema y preferencias',
    'settings.profile': 'Perfil',
    'settings.account': 'Cuenta',
    'settings.security': 'Seguridad',
    'settings.language': 'Idioma',
    'settings.theme': 'Tema',
    'settings.profile_info': 'Información del Perfil',
    'settings.preferences': 'Preferencias',
    'settings.availability': 'Disponibilidad',
    'settings.change_password': 'Cambiar Contraseña',
    'settings.current_password': 'Contraseña Actual',
    'settings.new_password': 'Nueva Contraseña',
    'settings.confirm_password': 'Confirmar Contraseña',
    'settings.professional_data': 'Datos profesionales',
    'settings.professional_license': 'Cédula profesional',
    'settings.specialty': 'Especialidad',
    'settings.save_professional_data': 'Guardar datos profesionales',
    'settings.confirm_label': 'Confirmar',
    'settings.update_password': 'Actualizar contraseña',
    'settings.auto_logout': 'Cierre de sesión automático',
    'settings.auto_logout_desc': 'Tiempo de inactividad antes de cerrar sesión',
    'settings.timeout_1h': '1 hora',
    'settings.timeout_4h': '4 horas',
    'settings.timeout_8h': '8 horas',
    'settings.timeout_never': 'Nunca',
    'settings.availability_config': 'Configuración de disponibilidad',
    'settings.new_exception_label': 'Nueva excepción',
    'settings.no_exceptions': 'Sin excepciones',
    'settings.no_exceptions_hint': 'Agrega fechas especiales o días cerrados',
    'settings.password_mismatch': 'Las contraseñas no coinciden',
    'settings.password_updated': 'Contraseña actualizada',
    'settings.password_updated_desc': 'Tu contraseña ha sido cambiada correctamente',
    'settings.professional_saved': 'Datos profesionales actualizados',
    'settings.availability_load_error': 'Error al cargar la configuración de disponibilidad',
    'settings.availability_saved': 'Reglas de disponibilidad actualizadas',
    'settings.window_added': 'Ventana semanal agregada',
    'settings.exception_added': 'Excepción de fecha agregada',
    'settings.saving': 'Guardando…',
    'settings.saved': 'Guardado',
    'settings.save_error': 'Error al guardar',

    // Auth
    'auth.login_title': 'Inicia sesión en tu cuenta',
    'auth.login_desc': 'Ingresa tus credenciales para acceder al sistema médico',
    'auth.email': 'Correo electrónico',
    'auth.password': 'Contraseña',
    'auth.remember_me': 'Recordarme',
    'auth.forgot_password': '¿Olvidaste tu contraseña?',
    'auth.sign_in': 'Iniciar Sesión',
    'auth.loading': 'Cargando...',
    'auth.welcome_back': '¡Bienvenido de nuevo!',
    'auth.login_error': 'Error de inicio de sesión',
    'auth.login_error_desc': 'Correo o contraseña inválidos. Inténtalo de nuevo.',
    'auth.logout': 'Cerrar Sesión',
    'auth.user_profile': 'Perfil de Usuario',
    'auth.show_password': 'Mostrar contraseña',
    'auth.hide_password': 'Ocultar contraseña',
    'auth.development_note': 'Usa una cuenta de personal existente, o crea una a través de la API de autenticación antes de iniciar sesión localmente.',
    'auth.portal_subtitle': 'Acceso seguro para el personal clínico. Ingresa tus credenciales para continuar.',

    // Portal
    'portal.title': 'Portal del Paciente',
    'portal.dashboard': 'Panel',
    'portal.my_appointments': 'Mis Citas',
    'portal.my_prescriptions': 'Mis Recetas',
    'portal.my_records': 'Mis Expedientes',
    'portal.my_messages': 'Mis Mensajes',
    'portal.my_bills': 'Mis Facturas',
    'portal.profile': 'Perfil',
    'portal.login': 'Iniciar Sesión',
    'portal.register': 'Registrarse',
    'portal.register_title': 'Crear cuenta',
    'portal.register_desc': 'Regístrate para acceder a tu portal de paciente',
    'portal.first_name': 'Nombre',
    'portal.last_name': 'Apellido',
    'portal.date_of_birth': 'Fecha de Nacimiento',
    'portal.gender': 'Género',
    'portal.create_account': 'Crear Cuenta',
    'portal.already_have_account': '¿Ya tienes una cuenta?',
    'portal.dont_have_account': '¿No tienes una cuenta?',
    'portal.sign_up': 'Registrarse',
    'portal.welcome': 'Bienvenido',
    'portal.upcoming_appointments': 'Próximas Citas',
    'portal.recent_prescriptions': 'Recetas Recientes',
    'portal.view_all': 'Ver Todo',
    
    // User menu
    'user_menu.profile': 'Perfil y Configuración',
    'user_menu.logout': 'Cerrar Sesión',
    
    // Notifications
    'notifications.title': 'Notificaciones',
    'notifications.no_new': 'No hay notificaciones nuevas',
    'notifications.mark_read': 'Marcar como leída',
    'notifications.mark_all_read': 'Marcar todas como leídas',
    'notifications.unread': 'sin leer',
    'notifications.approval.title': 'Cita pendiente de aprobación',
    'notifications.approval.desc': '{{patient}} solicitó una cita. {{reason}}',
    'notifications.upcoming.title': 'Próxima cita',
    'notifications.upcoming.desc': 'Cita con {{patient}} hoy',

    // Help
    'help.title': 'Ayuda',
    'help.subtitle': 'Navegación rápida, atajos de teclado y soporte.',
    'help.quick_links': 'Accesos rápidos',
    'help.shortcuts': 'Atajos de teclado',
    'help.shortcut.search': 'Buscar pacientes',
    'help.shortcut.help': 'Abrir esta ayuda',
    'help.shortcut.close': 'Cerrar ventanas',
    'help.support.title': '¿Necesitas más ayuda?',
    'help.support.body': 'Contacta al administrador de tu clínica para soporte o cambios de acceso.',
    
    // System
    'system.status': 'Estado del Sistema',
    'system.online': 'En línea',
    'system.offline': 'Sin conexión',
    'system.version': 'Versión',
    'system.all_operational': 'Todos los sistemas operativos',
    
    // Messages
    'messages.no_results': 'No se encontraron resultados',
    'messages.no_data': 'No hay datos disponibles',
    'messages.confirm_delete': '¿Estás seguro de que deseas eliminar esto?',
    'messages.delete_cancelled': 'Eliminación cancelada',
    'messages.created_success': 'Creado exitosamente',
    'messages.updated_success': 'Actualizado exitosamente',
    'messages.deleted_success': 'Eliminado exitosamente',
    'messages.error_saving': 'Error al guardar',
    'messages.error_loading': 'Error al cargar',
    'messages.error_deleting': 'Error al eliminar',
    
    // Validation
    'validation.required': 'Este campo es requerido',
    'validation.email_invalid': 'Correo electrónico inválido',
    'validation.password_min': 'La contraseña debe tener al menos {{min}} caracteres',
    'validation.password_match': 'Las contraseñas no coinciden',
    'validation.min_length': 'Debe tener al menos {{min}} caracteres',
    'validation.max_length': 'No debe exceder {{max}} caracteres',
    
    // Accessibility
    'a11y.open_menu': 'Abrir menú',
    'a11y.close_menu': 'Cerrar menú',
    'a11y.toggle_navigation': 'Alternar navegación',
    'a11y.user_menu': 'Menú de usuario',
    'a11y.notifications': 'Notificaciones',
    'a11y.search': 'Buscar',
    'a11y.main_content': 'Contenido principal',
    'a11y.skip_to_content': 'Saltar al contenido principal',
    
    // Time
    'time.today': 'Hoy',
    'time.yesterday': 'Ayer',
    'time.tomorrow': 'Mañana',
    'time.days_ago': 'hace {{days}} días',
    'time.hours_ago': 'hace {{hours}} horas',
    'time.minutes_ago': 'hace {{minutes}} minutos',
    'time.just_now': 'Justo ahora',
    
    // Workspace
    'workspace.overview': 'Resumen',
    'workspace.appointments': 'Citas',
    'workspace.lab': 'Laboratorio',
    'workspace.billing': 'Facturación',
    'workspace.pharmacy': 'Farmacia',
    'workspace.notes': 'Notas',
    'workspace.patient_chart': 'Expediente del Paciente',
    'workspace.medical_history': 'Historial Médico',
    'workspace.vitals': 'Signos Vitales',
    'workspace.diagnoses': 'Diagnósticos',
    'workspace.medications': 'Medicamentos',
    'workspace.immunizations': 'Vacunas',
    'workspace.documents': 'Documentos',
    
    // Gender options
    'gender.male': 'Masculino',
    'gender.female': 'Femenino',
    'gender.other': 'Otro',
    'gender.prefer_not_to_say': 'Prefiero no decirlo',
    
    // Blood types
    'blood_type.a_positive': 'A+',
    'blood_type.a_negative': 'A-',
    'blood_type.b_positive': 'B+',
    'blood_type.b_negative': 'B-',
    'blood_type.ab_positive': 'AB+',
    'blood_type.ab_negative': 'AB-',
    'blood_type.o_positive': 'O+',
    'blood_type.o_negative': 'O-',
    
    // Priority levels
    'priority.low': 'Baja',
    'priority.medium': 'Media',
    'priority.high': 'Alta',
    'priority.urgent': 'Urgente',
    
    // Pagination
    'pagination.previous': 'Anterior',
    'pagination.next': 'Siguiente',
    'pagination.page': 'Página {{page}} de {{total}}',
    'pagination.showing': 'Mostrando {{from}} a {{to}} de {{total}} resultados',

    // Extra status
    'status.critical': 'Crítico',
    'status.transferred': 'Transferido',

    // Common extras
    'common.all': 'Todos',

    // Gender extras
    'gender.non_binary': 'No binario',

    // Dashboard extras
    'dashboard.atelier_overview': 'Vista General del Atelier',
    'dashboard.clinic_status': 'Estado de la Clínica',
    'dashboard.lab_status': 'Lab: Análisis Clínico',
    'dashboard.results_ready': 'Resultados listos para revisión.',
    'dashboard.recent_label': 'Reciente',
    'dashboard.monthly_report': 'Reporte Mensual',
    'dashboard.report_generated': 'El reporte de rendimiento ha sido generado.',
    'dashboard.two_hours_ago': 'Hace 2 horas',
    'dashboard.next_consultation': 'Siguiente Consulta',
    'dashboard.general_consultation': 'Consulta General',
    'dashboard.next_available': 'Próxima disponible',
    'dashboard.main_office': 'Consultorio Principal',
    'dashboard.pending_bills_notice': 'Tienes facturas pendientes por {{amount}}.',

    // Patients extras
    'patients.no_next_appointment': 'Sin próxima cita',
    'patients.new_admissions': 'Nuevos Ingresos',
    'patients.trend_this_month': '+12% este mes',
    'patients.high_satisfaction': 'Alta satisfacción',
    'patients.adjust_search': 'Intenta ajustar tu búsqueda',
    'patients.start_adding': 'Comienza agregando un nuevo paciente',
    'patients.col_next_appointment': 'Próxima Cita',
    'patients.col_id': 'ID',
    'patients.col_name': 'Nombre',
    'patients.col_status': 'Estado',
    'patients.years_old': '{{age}} años',
    'patients.nav_back': 'Pacientes',
    'patients.record_prefix': 'Exp.',
    'patients.showing': 'Mostrando {{from}} a {{to}} de {{total}} pacientes',
    'patients.back_to_patients': 'Volver a Pacientes',

    // Workspace tab labels
    'workspace.sections_label': 'Secciones',
    'workspace.tab_summary': 'Resumen',
    'workspace.tab_summary_desc': 'Resumen clínico actual derivado de notas firmadas',
    'workspace.tab_patient_data': 'Datos del Paciente',
    'workspace.tab_patient_data_desc': 'Datos personales y contacto',
    'workspace.tab_diagnosis': 'Diagnóstico',
    'workspace.tab_diagnosis_desc': 'Consulta activa y diagnóstico',
    'workspace.tab_progress_notes': 'Notas de Evolución',
    'workspace.tab_progress_notes_desc': 'Notas de evolución por visita, resumen de evolución y addendums',
    'workspace.tab_clinical_history': 'Historia Clínica',
    'workspace.tab_clinical_history_desc': 'Antecedentes médicos completos',
    'workspace.tab_labs': 'Laboratorios',
    'workspace.tab_labs_desc': 'Laboratorios y gabinete',
    'workspace.tab_appointment_history': 'Historial de Citas',
    'workspace.tab_appointment_history_desc': 'Historial y programación de citas',
    'workspace.tab_reception_notes': 'Notas de recepción',
    'workspace.tab_reception_notes_desc': 'Lo que el paciente contó por WhatsApp o en mostrador',
  },
  en: {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.patients': 'Patients',
    'nav.appointments': 'Appointments',
    'nav.billing': 'Billing',
    'nav.pharmacy': 'Pharmacy',
    'nav.lab': 'Laboratory',
    'nav.analytics': 'Analytics',
    'nav.safety': 'Safety Inbox',
    'nav.audit': 'Audit Logs',
    'nav.organizations': 'Organizations',
    'nav.feature_flags': 'Feature Flags',
    'nav.ai_chat': 'AI Chat',
    'nav.settings': 'Settings',
    'nav.clinic': 'Clinic',
    'nav.system': 'System',

    // Sidebar (rendered navigation labels)
    'sidebar.home': 'Home',
    'sidebar.group.main': 'Main',
    'sidebar.group.clinical': 'Clinical',
    'sidebar.group.administrative': 'Administrative',
    'sidebar.group.system': 'System',
    'sidebar.agenda': 'Agenda',
    'sidebar.patients': 'Patients',
    'sidebar.appointments': 'Appointments',
    'sidebar.availability': 'My Availability',
    'sidebar.billing': 'Billing',
    'sidebar.medications': 'Medications',
    'sidebar.settings': 'Settings',
    'sidebar.audit': 'Audit',
    'sidebar.new_appointment': 'New Appointment',
    'sidebar.logout': 'Log Out',
    'settings.page_title': 'Settings',
    'settings.page_subtitle': 'Refine your clinical workspace. Manage your professional profile, system behaviors, and availability windows.',
    'settings.profile_information': 'Profile Information',
    'settings.full_name': 'Full Name',
    'settings.email': 'Email',
    'settings.role': 'Role',
    'settings.clinic_availability': 'Clinical Availability',
    'settings.timezone': 'Time Zone',
    'settings.consult_duration': 'Consultation Duration',
    'settings.lead_time': 'Lead Time',
    'settings.max_horizon': 'Maximum Horizon',
    'settings.unit_min': 'min',
    'settings.unit_days': 'days',
    'settings.save_rules': 'Save Rules',
    'settings.system_preferences': 'System Preferences',
    'settings.language_desc': 'Interface language.',
    'settings.weekly_windows': 'Weekly Windows',
    'settings.no_weekly_windows': 'No weekly windows configured.',
    'settings.add_window_hint': 'Add a window to get started.',
    'settings.add_window': 'Add schedule',
    'settings.add_exception_window': 'Add Exception Window',
    'settings.exception': 'Exception',
    'settings.date_exceptions': 'Date Exceptions',
    'settings.closed': 'Closed',
    'settings.discard_changes': 'Discard Changes',
    'settings.save_changes': 'Save Changes',
    'settings.weekday_short_0': 'Mon',
    'settings.weekday_short_1': 'Tue',
    'settings.weekday_short_2': 'Wed',
    'settings.weekday_short_3': 'Thu',
    'settings.weekday_short_4': 'Fri',
    'settings.weekday_short_5': 'Sat',
    'settings.weekday_short_6': 'Sun',
    'settings.theme_color': 'Theme color',
    'settings.theme_color_desc': 'Customize the main interface color.',
    'settings.theme_specialty': 'Theme by specialty',
    'settings.theme_specialty_desc': 'Apply a predefined palette for your specialty.',
    'settings.theme_peds_name': 'Pediatrics',
    'settings.theme_gyne_name': 'Gynecology',
    'settings.theme_general_name': 'General',
    'settings.theme_professional_name': 'Professional',
    'settings.theme_peds_desc': 'Warm, friendly and clean',
    'settings.theme_gyne_desc': 'Soft and sophisticated',
    'settings.theme_general_desc': 'Versatile and reliable',
    'settings.theme_professional_desc': 'Serious and premium',
    'settings.dark_mode': 'Dark mode',
    'settings.theme_reset': 'Reset',
    'settings.theme_preview': 'Preview',
    'settings.preview_card_title': 'Sample card',
    'settings.preview_card_dimmed': 'Dimmed secondary text',
    'settings.preview_primary': 'Primary',
    'settings.preview_secondary': 'Accent',
    'settings.preview_input': 'Focused field',
    'availability.schedule_saved': 'Schedule saved successfully',
    'availability.schedule_save_error': 'Could not save the schedule',

    // Common actions
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.view': 'View',
    'common.search': 'Search',
    'common.patient': 'Patient',
    'common.dismiss': 'Dismiss',
    'common.filter': 'Filter',
    'common.export': 'Export',
    'common.import': 'Import',
    'common.create': 'Create',
    'common.add': 'Add',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.close': 'Close',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.previous': 'Previous',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.confirm': 'Confirm',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.date': 'Date',
    'common.time': 'Time',
    'common.description': 'Description',
    'common.name': 'Name',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.address': 'Address',
    'common.notes': 'Notes',
    'common.clear': 'Clear',
    'common.unread': 'unread',
    'common.development': 'Local Development',
    'common.all_rights_reserved': 'All rights reserved',
    'common.privacy_policy': 'Privacy Policy',
    'common.terms_of_service': 'Terms of Service',
    'common.support': 'Support',

    // Status
    'status.active': 'Active',
    'status.inactive': 'Inactive',
    'status.discharged': 'Discharged',
    'status.pending': 'Pending',
    'status.completed': 'Completed',
    'status.cancelled': 'Cancelled',
    'status.confirmed': 'Confirmed',

    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.subtitle': 'Welcome back',
    'dashboard.metrics.title': 'Key metrics',
    'dashboard.metrics.total_patients': 'Total Patients',
    'dashboard.metrics.appointments_today': "Today's Appointments",
    'dashboard.metrics.pending_bills': 'Pending Bills',
    'dashboard.metrics.avg_duration': 'Avg. Duration',
    'dashboard.quick_actions': 'Quick Actions',
    'dashboard.actions_description': 'Frequent operations',
    'dashboard.recent_activity': 'Recent Activity',
    'dashboard.attention_required': 'Requires Attention',
    'dashboard.todays_agenda': "Today's Agenda",
    'dashboard.no_appointments_today': 'No appointments scheduled for today',
    'dashboard.greeting_morning': 'Good morning',
    'dashboard.greeting_afternoon': 'Good afternoon',
    'dashboard.greeting_evening': 'Good evening',

    // Quick actions
    'quick_actions.register_patient': 'Register New Patient',
    'quick_actions.register_patient_desc': 'Create a new patient record',
    'quick_actions.schedule_appointment': 'Schedule Appointment',
    'quick_actions.schedule_appointment_desc': 'Book a new appointment',
    'quick_actions.create_prescription': 'Create Prescription',
    'quick_actions.create_prescription_desc': 'Write a new prescription',
    'quick_actions.open_safety_inbox': 'Open Safety Inbox',
    'quick_actions.open_safety_inbox_desc': 'Review unresolved clinical safety events',

    // Patients
    'patients.title': 'Patients',
    'patients.subtitle': 'Manage patient records, medical histories, and care plans',
    'patients.search_placeholder': 'Search by name, email, or phone...',
    'patients.new_patient': 'New Patient',
    'patients.edit_patient': 'Edit Patient',
    'patients.view_profile': 'View Profile',
    'patients.open_chart': 'Open Chart',
    'patients.no_results': 'No patients found',
    'patients.no_results_desc': 'Try different search terms or register a new patient',
    'patients.total': 'Total Patients',

    // Patient form
    'patient.form.first_name': 'First Name(s)',
    'patient.form.last_name': 'Last Name(s)',
    'patient.form.email': 'Email',
    'patient.form.phone': 'Phone',
    'patient.form.date_of_birth': 'Date of birth',
    'patient.form.gender': 'Gender',
    'patient.form.address': 'Address',
    'patient.form.occupation': 'Occupation',
    'patient.form.emergency_contact': 'Emergency contact',
    'patient.form.emergency_phone': 'Emergency phone',
    'patient.form.blood_type': 'Blood type',
    'patient.form.allergies': 'Allergies',
    'patient.form.medical_history': 'Medical history',
    'patient.form.create_title': 'Register New Patient',
    'patient.form.edit_title': 'Edit Patient',
    'patient.form.create_desc': 'Fill out the form to create a new record',
    'patient.form.edit_desc': 'Update the patient information',

    // Appointments
    'appointments.title': 'Appointments',
    'appointments.subtitle': 'Schedule and manage patient appointments',
    'appointments.new_appointment': 'New Appointment',
    'appointments.edit_appointment': 'Edit Appointment',
    'appointments.create_title': 'Create New Appointment',
    'appointments.create_description': 'Schedule a new appointment for a patient',
    'appointments.today': 'Today',
    'appointments.month': 'Month',
    'appointments.week': 'Week',
    'appointments.day': 'Day',
    'appointments.doctor': 'Doctor',
    'appointments.patient': 'Patient',
    'appointments.date_time': 'Date and Time',
    'appointments.date': 'Date',
    'appointments.type': 'Appointment Type',
    'appointments.reason': 'Reason',
    'appointments.status': 'Status',
    'appointments.notes': 'Notes',
    'appointments.no_appointments': 'No appointments scheduled',
    'appointments.available_slots': 'Available Slots',
    'appointments.select_slot': 'Select an available slot',
    'appointments.book_appointment': 'Book Appointment',
    'appointments.error_loading': 'Error loading appointments',
    'appointments.error_creating': 'Error creating appointment',
    'appointments.error_loading_slots': 'Error loading available slots',
    'appointments.created_success': 'Appointment created successfully',
    'appointments.enter_patient_id': 'Enter the patient ID',
    'appointments.enter_doctor_id': 'Enter the doctor ID',
    'appointments.duration': 'Duration',
    'appointments.minutes': 'min',
    'appointments.select_type': 'Select type',
    'appointments.no_slots_available': 'No slots available for this date',
    'appointment_type.consultation': 'Consultation',
    'appointment_type.follow_up': 'Follow-up',
    'appointment_type.emergency': 'Emergency',
    'appointment_type.routine_checkup': 'Routine Checkup',
    'appointment_type.vaccination': 'Vaccination',
    'appointment_type.lab_test': 'Lab Test',
    'appointment_type.telemedicine': 'Telemedicine',

    // Billing
    'billing.title': 'Billing',
    'billing.subtitle': 'Manage invoices, payments, and insurance claims',
    'billing.new_invoice': 'New Invoice',
    'billing.invoice_number': 'Invoice Number',
    'billing.amount': 'Amount',
    'billing.paid': 'Paid',
    'billing.pending': 'Pending',
    'billing.overdue': 'Overdue',
    'billing.due_date': 'Due Date',
    'billing.issue_date': 'Issue Date',
    'billing.payment_method': 'Payment Method',
    'billing.insurance': 'Insurance',
    'billing.insurance_company': 'Insurance Company',
    'billing.policy_number': 'Policy Number',
    'billing.subtotal': 'Subtotal',
    'billing.tax': 'Tax',
    'billing.total': 'Total',
    'billing.pay': 'Pay',
    'billing.download': 'Download',

    // Pharmacy
    'pharmacy.title': 'Pharmacy',
    'pharmacy.subtitle': 'Manage medication inventory and prescriptions',
    'pharmacy.new_prescription': 'New Prescription',
    'pharmacy.medication': 'Medication',
    'pharmacy.dosage': 'Dosage',
    'pharmacy.frequency': 'Frequency',
    'pharmacy.duration': 'Duration',
    'pharmacy.quantity': 'Quantity',
    'pharmacy.instructions': 'Instructions',
    'pharmacy.prescribed_date': 'Prescribed Date',
    'pharmacy.prescribed_by': 'Prescribed by',
    'pharmacy.stock': 'Stock',
    'pharmacy.low_stock': 'Low Stock',
    'pharmacy.out_of_stock': 'Out of Stock',
    'pharmacy.add_medication': 'Add Medication',
    'pharmacy.edit_medication': 'Edit Medication',

    // Laboratory
    'lab.title': 'Laboratory',
    'lab.subtitle': 'Manage lab orders and results',
    'lab.new_order': 'New Order',
    'lab.test_type': 'Test Type',
    'lab.test_name': 'Test Name',
    'lab.results': 'Results',
    'lab.pending_results': 'Pending Results',
    'lab.review_results': 'Review Results',
    'lab.ordered_date': 'Ordered Date',
    'lab.completed_date': 'Completed Date',
    'lab.ordering_doctor': 'Ordering Doctor',
    'lab.priority': 'Priority',
    'lab.normal': 'Normal',
    'lab.abnormal': 'Abnormal',
    'lab.critical': 'Critical',
    'lab.upload_results': 'Upload Results',

    // Analytics
    'analytics.title': 'Analytics',
    'analytics.subtitle': 'System metrics and reports',
    'analytics.department_performance': 'Department Performance',
    'analytics.appointments_count': 'Appointment Count',
    'analytics.patients_count': 'Patient Count',
    'analytics.revenue': 'Revenue',
    'analytics.trend': 'Trend',
    'analytics.export_report': 'Export Report',

    // Safety
    'safety.title': 'Safety Inbox',
    'safety.subtitle': 'Clinical safety events and incident management',
    'safety.critical_events': 'Critical Events',
    'safety.pending_review': 'Pending Review',
    'safety.resolved': 'Resolved',
    'safety.event_type': 'Event Type',
    'safety.severity': 'Severity',
    'safety.due_date': 'Due Date',
    'safety.assigned_to': 'Assigned to',
    'safety.report_event': 'Report Event',

    // Audit
    'audit.title': 'Audit Logs',
    'audit.subtitle': 'System activity log',
    'audit.user': 'User',
    'audit.action': 'Action',
    'audit.resource': 'Resource',
    'audit.timestamp': 'Timestamp',
    'audit.ip_address': 'IP Address',
    'audit.details': 'Details',

    // Organizations
    'organizations.title': 'Organizations',
    'organizations.subtitle': 'Manage organizations and business units',
    'organizations.new_organization': 'New Organization',
    'organizations.business_units': 'Business Units',
    'organizations.new_business_unit': 'New Business Unit',
    'organizations.organization_name': 'Organization Name',
    'organizations.business_unit_name': 'Unit Name',

    // Feature Flags
    'feature_flags.title': 'Feature Flags',
    'feature_flags.subtitle': 'Manage system features',
    'feature_flags.enabled': 'Enabled',
    'feature_flags.disabled': 'Disabled',
    'feature_flags.toggle': 'Toggle',

    // AI Chat
    'ai_chat.title': 'AI Chat',
    'ai_chat.subtitle': 'Artificial intelligence assistant',
    'ai_chat.type_message': 'Type your message...',
    'ai_chat.send': 'Send',
    'ai_chat.thinking': 'Thinking...',

    // Settings
    'settings.title': 'Settings',
    'settings.subtitle': 'System settings and preferences',
    'settings.profile': 'Profile',
    'settings.account': 'Account',
    'settings.security': 'Security',
    'settings.language': 'Language',
    'settings.theme': 'Theme',
    'settings.profile_info': 'Profile Information',
    'settings.preferences': 'Preferences',
    'settings.availability': 'Availability',
    'settings.change_password': 'Change Password',
    'settings.current_password': 'Current Password',
    'settings.new_password': 'New Password',
    'settings.confirm_password': 'Confirm Password',
    'settings.professional_data': 'Professional Data',
    'settings.professional_license': 'Professional License',
    'settings.specialty': 'Specialty',
    'settings.save_professional_data': 'Save Professional Data',
    'settings.confirm_label': 'Confirm',
    'settings.update_password': 'Update password',
    'settings.auto_logout': 'Automatic session timeout',
    'settings.auto_logout_desc': 'Inactivity time before logging out',
    'settings.timeout_1h': '1 hour',
    'settings.timeout_4h': '4 hours',
    'settings.timeout_8h': '8 hours',
    'settings.timeout_never': 'Never',
    'settings.availability_config': 'Availability configuration',
    'settings.new_exception_label': 'New exception',
    'settings.no_exceptions': 'No exceptions',
    'settings.no_exceptions_hint': 'Add special dates or closed days',
    'settings.password_mismatch': 'Passwords do not match',
    'settings.password_updated': 'Password updated',
    'settings.password_updated_desc': 'Your password has been changed successfully',
    'settings.professional_saved': 'Professional data updated',
    'settings.availability_load_error': 'Error loading availability configuration',
    'settings.availability_saved': 'Availability rules updated',
    'settings.window_added': 'Weekly window added',
    'settings.exception_added': 'Date exception added',
    'settings.saving': 'Saving…',
    'settings.saved': 'Saved',
    'settings.save_error': 'Error saving',

    // Auth
    'auth.login_title': 'Sign in to your account',
    'auth.login_desc': 'Enter your credentials to access the medical system',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.remember_me': 'Remember me',
    'auth.forgot_password': 'Forgot your password?',
    'auth.sign_in': 'Sign In',
    'auth.loading': 'Loading...',
    'auth.welcome_back': 'Welcome back!',
    'auth.login_error': 'Login error',
    'auth.login_error_desc': 'Invalid email or password. Please try again.',
    'auth.logout': 'Log Out',
    'auth.user_profile': 'User Profile',
    'auth.show_password': 'Show password',
    'auth.hide_password': 'Hide password',
    'auth.development_note': 'Use an existing staff account, or create one through the authentication API before signing in locally.',
    'auth.portal_subtitle': 'Secure access for clinical staff. Enter your credentials to continue.',

    // Portal
    'portal.title': 'Patient Portal',
    'portal.dashboard': 'Dashboard',
    'portal.my_appointments': 'My Appointments',
    'portal.my_prescriptions': 'My Prescriptions',
    'portal.my_records': 'My Records',
    'portal.my_messages': 'My Messages',
    'portal.my_bills': 'My Bills',
    'portal.profile': 'Profile',
    'portal.login': 'Sign In',
    'portal.register': 'Register',
    'portal.register_title': 'Create account',
    'portal.register_desc': 'Sign up to access your patient portal',
    'portal.first_name': 'First Name',
    'portal.last_name': 'Last Name',
    'portal.date_of_birth': 'Date of Birth',
    'portal.gender': 'Gender',
    'portal.create_account': 'Create Account',
    'portal.already_have_account': 'Already have an account?',
    'portal.dont_have_account': "Don't have an account?",
    'portal.sign_up': 'Sign Up',
    'portal.welcome': 'Welcome',
    'portal.upcoming_appointments': 'Upcoming Appointments',
    'portal.recent_prescriptions': 'Recent Prescriptions',
    'portal.view_all': 'View All',

    // User menu
    'user_menu.profile': 'Profile & Settings',
    'user_menu.logout': 'Log Out',

    // Notifications
    'notifications.title': 'Notifications',
    'notifications.no_new': 'No new notifications',
    'notifications.mark_read': 'Mark as read',
    'notifications.mark_all_read': 'Mark all as read',
    'notifications.unread': 'unread',
    'notifications.approval.title': 'Appointment awaiting approval',
    'notifications.approval.desc': '{{patient}} requested an appointment. {{reason}}',
    'notifications.upcoming.title': 'Upcoming appointment',
    'notifications.upcoming.desc': 'Appointment with {{patient}} today',

    // Help
    'help.title': 'Help',
    'help.subtitle': 'Quick navigation, keyboard shortcuts and support.',
    'help.quick_links': 'Quick links',
    'help.shortcuts': 'Keyboard shortcuts',
    'help.shortcut.search': 'Search patients',
    'help.shortcut.help': 'Open this help',
    'help.shortcut.close': 'Close dialogs',
    'help.support.title': 'Need more help?',
    'help.support.body': 'Contact your clinic administrator for support or access changes.',

    // System
    'system.status': 'System Status',
    'system.online': 'Online',
    'system.offline': 'Offline',
    'system.version': 'Version',
    'system.all_operational': 'All systems operational',

    // Messages
    'messages.no_results': 'No results found',
    'messages.no_data': 'No data available',
    'messages.confirm_delete': 'Are you sure you want to delete this?',
    'messages.delete_cancelled': 'Deletion cancelled',
    'messages.created_success': 'Created successfully',
    'messages.updated_success': 'Updated successfully',
    'messages.deleted_success': 'Deleted successfully',
    'messages.error_saving': 'Error saving',
    'messages.error_loading': 'Error loading',
    'messages.error_deleting': 'Error deleting',

    // Validation
    'validation.required': 'This field is required',
    'validation.email_invalid': 'Invalid email address',
    'validation.password_min': 'Password must be at least {{min}} characters',
    'validation.password_match': 'Passwords do not match',
    'validation.min_length': 'Must be at least {{min}} characters',
    'validation.max_length': 'Must not exceed {{max}} characters',

    // Accessibility
    'a11y.open_menu': 'Open menu',
    'a11y.close_menu': 'Close menu',
    'a11y.toggle_navigation': 'Toggle navigation',
    'a11y.user_menu': 'User menu',
    'a11y.notifications': 'Notifications',
    'a11y.search': 'Search',
    'a11y.main_content': 'Main content',
    'a11y.skip_to_content': 'Skip to main content',

    // Time
    'time.today': 'Today',
    'time.yesterday': 'Yesterday',
    'time.tomorrow': 'Tomorrow',
    'time.days_ago': '{{days}} days ago',
    'time.hours_ago': '{{hours}} hours ago',
    'time.minutes_ago': '{{minutes}} minutes ago',
    'time.just_now': 'Just now',

    // Workspace
    'workspace.overview': 'Overview',
    'workspace.appointments': 'Appointments',
    'workspace.lab': 'Laboratory',
    'workspace.billing': 'Billing',
    'workspace.pharmacy': 'Pharmacy',
    'workspace.notes': 'Notes',
    'workspace.patient_chart': 'Patient Chart',
    'workspace.medical_history': 'Medical History',
    'workspace.vitals': 'Vitals',
    'workspace.diagnoses': 'Diagnoses',
    'workspace.medications': 'Medications',
    'workspace.immunizations': 'Immunizations',
    'workspace.documents': 'Documents',

    // Gender options
    'gender.male': 'Male',
    'gender.female': 'Female',
    'gender.other': 'Other',
    'gender.prefer_not_to_say': 'Prefer not to say',

    // Blood types
    'blood_type.a_positive': 'A+',
    'blood_type.a_negative': 'A-',
    'blood_type.b_positive': 'B+',
    'blood_type.b_negative': 'B-',
    'blood_type.ab_positive': 'AB+',
    'blood_type.ab_negative': 'AB-',
    'blood_type.o_positive': 'O+',
    'blood_type.o_negative': 'O-',

    // Priority levels
    'priority.low': 'Low',
    'priority.medium': 'Medium',
    'priority.high': 'High',
    'priority.urgent': 'Urgent',

    // Pagination
    'pagination.previous': 'Previous',
    'pagination.next': 'Next',
    'pagination.page': 'Page {{page}} of {{total}}',
    'pagination.showing': 'Showing {{from}} to {{to}} of {{total}} results',

    // Extra status
    'status.critical': 'Critical',
    'status.transferred': 'Transferred',

    // Common extras
    'common.all': 'All',

    // Gender extras
    'gender.non_binary': 'Non-binary',

    // Dashboard extras
    'dashboard.atelier_overview': 'Atelier Overview',
    'dashboard.clinic_status': 'Clinic Status',
    'dashboard.lab_status': 'Lab: Clinical Analysis',
    'dashboard.results_ready': 'Results ready for review.',
    'dashboard.recent_label': 'Recent',
    'dashboard.monthly_report': 'Monthly Report',
    'dashboard.report_generated': 'The performance report has been generated.',
    'dashboard.two_hours_ago': '2 hours ago',
    'dashboard.next_consultation': 'Next Consultation',
    'dashboard.general_consultation': 'General Consultation',
    'dashboard.next_available': 'Next available',
    'dashboard.main_office': 'Main Office',
    'dashboard.pending_bills_notice': 'You have pending bills for {{amount}}.',

    // Patients extras
    'patients.no_next_appointment': 'No upcoming appointment',
    'patients.new_admissions': 'New Admissions',
    'patients.trend_this_month': '+12% this month',
    'patients.high_satisfaction': 'High satisfaction',
    'patients.adjust_search': 'Try adjusting your search',
    'patients.start_adding': 'Start by adding a new patient',
    'patients.col_next_appointment': 'Next Appointment',
    'patients.col_id': 'ID',
    'patients.col_name': 'Name',
    'patients.col_status': 'Status',
    'patients.years_old': '{{age}} yrs',
    'patients.nav_back': 'Patients',
    'patients.record_prefix': 'Rec.',
    'patients.showing': 'Showing {{from}} to {{to}} of {{total}} patients',
    'patients.back_to_patients': 'Back to Patients',

    // Workspace tab labels
    'workspace.sections_label': 'Sections',
    'workspace.tab_summary': 'Summary',
    'workspace.tab_summary_desc': 'Current clinical summary derived from signed notes',
    'workspace.tab_patient_data': 'Patient Data',
    'workspace.tab_patient_data_desc': 'Personal and contact information',
    'workspace.tab_diagnosis': 'Diagnosis',
    'workspace.tab_diagnosis_desc': 'Active consultation and diagnosis',
    'workspace.tab_progress_notes': 'Progress Notes',
    'workspace.tab_progress_notes_desc': 'Visit progress notes, evolution summary and addendums',
    'workspace.tab_clinical_history': 'Clinical History',
    'workspace.tab_clinical_history_desc': 'Complete medical background',
    'workspace.tab_labs': 'Laboratories',
    'workspace.tab_labs_desc': 'Labs and imaging',
    'workspace.tab_appointment_history': 'Appointment History',
    'workspace.tab_appointment_history_desc': 'Appointment history and scheduling',
    'workspace.tab_reception_notes': 'Reception notes',
    'workspace.tab_reception_notes_desc': 'What the patient shared on WhatsApp or at the front desk',
  },
} as const
